import React, { useEffect, useState, useRef } from "react";
import "./adminStyles.css";
import { IoSearch } from "react-icons/io5";
import copy_icon from "../../assets/admin/copy_icon.webp";
import AdminSidebar from "./Sidebar/AdminSidebar";
import AdminHeader from "./Header/AdminHeader";

import { getMethod, postMethod } from "../../core/service/common.api";
import apiService from "../../core/service/detail";
import { toast } from "react-hot-toast";
import ReactPaginate from "react-paginate";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import moment from "moment";
import { CSVLink } from "react-csv";
import { useReactToPrint } from "react-to-print";
import UserHistoryPDF from "./new";
// import { jsPDF } from 'jspdf';
import { PDFDownloadLink } from "@react-pdf/renderer";
import CircularProgress from "@mui/material/CircularProgress";
import Skeleton from "@mui/material/Skeleton";

const UserManagement = () => {
  const [sortFilter, setSortFilter] = useState("Newest Date");

  const obfuscateEmail = (email) => {
    if (!email) return "";
    const [localPart, domainPart] = email.split("@");
    const firstFive = localPart.slice(0, 5);
    return `${firstFive}...${domainPart}`;
  };
  const showsuccessToast = (message) => {
    toast.dismiss();
    toast.success(message);
  };

  const showerrorToast = (message) => {
    toast.dismiss();
    toast.error(message);
  };
  const copy = async (text, msg) => {
    navigator.clipboard.writeText(text);
    console.log(text, "text");
    showsuccessToast(msg + " copied");
  };

  //login History
  const [userData, setuserData] = useState([]);
  const [userDataCSV, setuserDataCSV] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(""); // e.g., "approved", "pending"

  const handleFilterChange = (e) => {
    const value = e.target.value;
    if (value.length === 1 && value[0] === " ") return;
    setSearchTerm(value);
  };
  useEffect(() => {
    getuserHistoryCSV();
  }, [0]);
  useEffect(() => {
    getuserHistory(currentPage);
  }, [currentPage, searchTerm]);

  const getuserHistory = async (page) => {
    try {
      const UserObj = {
        page: page ? page : currentPage,
        perpage: 5,
        search: searchTerm,
      };
      setLoader(true);
      var data = {
        apiUrl: apiService.userManagement,
        payload: UserObj,
      };
      var resp = await postMethod(data);
      setLoader(false);
      if (resp.status == true) {
        setuserData(resp.data);
        console.log(resp.data, "resp.data");
        console.log(userData, "userData");
        setTotalPages(resp.totalPages);
      } else {
        setuserData([]);
      }
    } catch (err) {
      console.log(err, "=-==-");
    }
  };
  const getuserHistoryCSV = async () => {
    try {
      setLoader(true);
      var data = {
        apiUrl: apiService.getuserHistoryCSV,
      };
      var resp = await postMethod(data);
      setLoader(false);
      setuserDataCSV(resp.data);
    } catch (err) {}
  };
  const handlePageClick = (data) => {
    setCurrentPage(data);
    getuserHistory(data);
  };

  //   const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  //   const [windowStart, setWindowStart] = useState(1);
  //   const windowSize = 3;

  //   useEffect(() => {
  //     // Adjust window if currentPage moves outside the visible range
  //     if (currentPage < windowStart) {
  //       setWindowStart(currentPage);
  //     } else if (currentPage >= windowStart + windowSize) {
  //       setWindowStart(currentPage - windowSize + 1);
  //     }
  //   }, [currentPage]);

  //   const renderPageButtons = () => {
  //     const pages = [];
  //     const windowEnd = Math.min(windowStart + windowSize - 1, totalPages);

  //     for (let i = windowStart; i <= windowEnd; i++) {
  //       pages.push(
  //         <li key={i} className={`page-item ${currentPage === i ? "active" : ""}`}>
  //           <button className="page-link" onClick={() => onPageChange(i)}>
  //             {i}
  //           </button>
  //         </li>
  //       );
  //     }

  //     return pages;
  //   };

  //   const handlePrevWindow = () => {
  //     if (windowStart > 1) {
  //       const newStart = Math.max(windowStart - windowSize, 1);
  //       setWindowStart(newStart);
  //       onPageChange(newStart);
  //     }
  //   };

  //   const handleNextWindow = () => {
  //     if (windowStart + windowSize <= totalPages) {
  //       const newStart = windowStart + windowSize;
  //       setWindowStart(newStart);
  //       onPageChange(newStart);
  //     }
  //   };

  //   return (
  //     <nav aria-label="Page navigation example">
  //       <ul className="pagination custom_pagination">
  //         <li className={`page-item ${windowStart === 1 ? "disabled" : ""}`}>
  //           <button className="page-link" onClick={handlePrevWindow}>
  //             <FaArrowLeft />
  //           </button>
  //         </li>

  //         {renderPageButtons()}

  //         <li
  //           className={`page-item ${
  //             windowStart + windowSize > totalPages ? "disabled" : ""
  //           }`}
  //         >
  //           <button className="page-link" onClick={handleNextWindow}>
  //             <FaArrowRight />
  //           </button>
  //         </li>
  //       </ul>
  //     </nav>
  //   );
  // };

  const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const [windowStart, setWindowStart] = useState(currentPage);
    const windowSize = 3;

    useEffect(() => {
      // Adjust window if currentPage moves outside the visible range
      if (currentPage < windowStart) {
        setWindowStart(currentPage);
      } else if (currentPage >= windowStart + windowSize) {
        setWindowStart(currentPage - windowSize + 1);
      }
    }, [currentPage]);

    const renderPageButtons = () => {
      return (
        <ul className="page_num_wrp">
          {windowStart > 1 ? (
            <li key={windowStart - 1} className={`page-item`}>
              <button
                className="page-link"
                onClick={() => onPageChange(windowStart - 1)}
              >
                {windowStart - 1}
              </button>
            </li>
          ) : null}
          <li
            key={windowStart}
            className={`page-item ${
              currentPage === windowStart ? "active" : ""
            }`}
          >
            <button
              className="page-link"
              onClick={() => onPageChange(windowStart)}
            >
              {windowStart}
            </button>
          </li>
          {windowStart < totalPages ? (
            <li key={windowStart + 1} className={`page-item`}>
              <button
                className="page-link"
                onClick={() => onPageChange(windowStart + 1)}
              >
                {windowStart + 1}
              </button>
            </li>
          ) : null}
        </ul>
      );
    };

    const handlePrevWindow = () => {
      if (windowStart > 1) {
        const newStart = Math.max(windowStart - 1);
        setWindowStart(newStart);
        onPageChange(newStart);
      }
    };

    const handleNextWindow = () => {
      if (windowStart <= totalPages) {
        const newStart = windowStart + 1;
        setWindowStart(newStart);
        onPageChange(newStart);
      }
    };

    return (
      <nav aria-label="Page navigation example">
        <ul className="pagination custom_pagination">
          <li className={`page-item ${windowStart === 1 ? "disabled" : ""}`}>
            <button className="page-link" onClick={handlePrevWindow}>
              <FaArrowLeft />
            </button>
          </li>

          {renderPageButtons()}

          <li
            className={`page-item ${
              windowStart >= totalPages ? "disabled" : ""
            }`}
          >
            <button className="page-link" onClick={handleNextWindow}>
              <FaArrowRight />
            </button>
          </li>
        </ul>
      </nav>
    );
  };

  const handleSortBy = (e) => {
    const selectedFilter = e.target.innerText.trim(); // Use raw value
    setSortFilter(selectedFilter.toLowerCase()); // Still update state if needed

    let sortedData = [...userData];

    if (selectedFilter === "Newest Date") {
      sortedData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    } else if (selectedFilter === "Oldest Date") {
      sortedData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    } else if (selectedFilter === "Name A-Z") {
      sortedData.sort((a, b) => a.username.localeCompare(b.username));
    } else if (selectedFilter === "Name Z-A") {
      sortedData.sort((a, b) => b.username.localeCompare(a.username));
    }
    setuserData(sortedData);
  };

  return (
    <>
      <AdminHeader />

      <main className="main_flx userMang_main">
        <AdminSidebar />

        <div className="right_wrap pb-4">
          <div>
            <h3 className="inspge_title">User Management</h3>

            <div className="search_select_wrp usrMng_selct_wrp">
              <div className="pdf_csv_wrp">
                <button>
                  {" "}
                  <PDFDownloadLink
                    document={<UserHistoryPDF data={userDataCSV} />}
                    fileName="user_report.pdf"
                  >
                    PDF
                    {/* {({ loading }) =>
                        loading ? "Loading document..." : "PDF"
                      } */}
                  </PDFDownloadLink>
                </button>
                <button>
                  <CSVLink data={userDataCSV} filename={"my-data.csv"}>
                    csv
                  </CSVLink>
                </button>
              </div>
              <div className="search_main">
                <input
                  src="text"
                  placeholder="Search by username or wallet"
                  value={searchTerm}
                  maxLength={20}
                  onChange={handleFilterChange}
                />
                <IoSearch />
              </div>
              <div className="select_main">
                <div className="dropdown">
                  <button
                    className="btn btn-secondary dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Filter by : <span>{sortFilter}</span>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={handleSortBy}
                      >
                        Newest Date
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={handleSortBy}
                      >
                        Name A-Z
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={handleSortBy}
                      >
                        Name Z-A
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={handleSortBy}
                      >
                        Oldest Date
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="userMnge_table_wrp">
              <div className="table-respo usermnge_table_main table-common">
                {/* {loader == true ? (
                    <span className="loader_user">
                      <CircularProgress size={40}  />
                    </span>
                  ) : ( */}
                <>
                  <div className="table">
                    <div className="thead">
                      <div className="tr">
                        <span className="th tbl_serlno">S:NO</span>
                        <span className="th">User Name</span>
                        <span className="th">Wallet ID</span>
                        {/* <span className="th">Email ID</span> */}
                        <span className="th">Created Date & Time</span>
                      </div>
                    </div>

                    {loader ? (
                      <>
                        <div className="tbody">
                          {Array.from({ length: 5 }).map((_, index) => (
                            <div className="tr" key={index}>
                              <span className="table_td td tbl_serlno">
                                <Skeleton
                                  variant="text"
                                  className="table_skl_txt"
                                />
                              </span>
                              <span className="table_td td">
                                <Skeleton
                                  variant="text"
                                  className="table_skl_txt"
                                />
                              </span>
                              <span className="table_td td">
                                <Skeleton
                                  variant="text"
                                  className="table_skl_txt"
                                />
                              </span>
                              <span className="table_td td">
                                <Skeleton
                                  variant="text"
                                  className="table_skl_txt"
                                />
                              </span>
                            </div>
                          ))}
                        </div>

                        <div className="mt-4 d-flex align-items-center justify-content-center gap-3">
                          <Skeleton
                            variant="circular"
                            className="skl_pagination_icon"
                          />
                          <Skeleton
                            variant="circular"
                            className="skl_pagination_icon"
                          />
                          <Skeleton
                            variant="circular"
                            className="skl_pagination_icon"
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="tbody">
                          {userData.length > 0 ? (
                            userData.map((item, index) => {
                              return (
                                <div className="tr">
                                  <span className="table_td td tbl_serlno">
                                    {index + 1}
                                  </span>
                                  <span className="table_td td">
                                    {item.username}
                                  </span>
                                  {/* <span className='table_td td'>{obfuscateEmail(item.walletID)}</span> */}
                                  <span className="table_td td tble_flx_cntr">
                                    <div className="copy-td-text">
                                      <span
                                        onClick={() =>
                                          copy(
                                            item.walletAddress,
                                            "Wallet Address"
                                          )
                                        }
                                      >
                                        <img
                                          src={copy_icon}
                                          alt="copy_icon"
                                          className="copy_icon"
                                        />
                                      </span>
                                      {/* {item.walletAddress} */}
                                      {`${item.walletAddress.slice(
                                        0,
                                        13
                                      )}...${item.walletAddress.slice(-4)}`}
                                    </div>
                                  </span>
                                  {/* <span className="table_td td">
                                {item.email}
                              </span> */}
                                  <span className="table_td td">
                                    {moment(item.createdAt).format("lll")}
                                  </span>
                                </div>
                              );
                            })
                          ) : (
                            <div className="tr">
                              <span className="table_td td ">
                                <div className="nodata_wrap">
                                  <img
                                    src={
                                      new URL(
                                        "../../assets/No-data.webp",
                                        import.meta.url
                                      )
                                    }
                                    alt=""
                                    className="no_data_img"
                                  />
                                  No record found
                                </div>
                              </span>
                            </div>
                          )}
                        </div>

                        {userData.length > 0 ? (
                          <div className="paginationcss">
                            <Pagination
                              currentPage={currentPage}
                              totalPages={totalPages}
                              onPageChange={(page) => {
                                handlePageClick(page);
                              }}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </div>
                </>
                {/* )} */}
              </div>
            </div>
          </div>
          {/* <div className="dsh_footer_wrap">
              <Footer />
            </div> */}
        </div>
      </main>
    </>
  );
};

export default UserManagement;
